export default __webpack_public_path__ + "static/media/molumen_phone_icon.d030b2ab.png";